import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Controller } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import InitTabs from '@utils/initTabs';
import FloorsGraphic from '@utils/FloorsGraphic';

document.addEventListener('DOMContentLoaded', function ()
{

    Fancybox.bind("[data-fancybox]", {
        Toolbar: {
            display: {
                left: ["infobar"],
                middle: [],
                right: ["close"],
            },
        },
    });

    const swGalleryInterior = document.querySelector('.swiper-gallery-interior');
    if (swGalleryInterior) {
        const swCaptionInterior = document.querySelector('.swiper-caption-interior');
        let swiperCaptionInterior = null;

        if (swCaptionInterior) {
            swiperCaptionInterior = new Swiper('.swiper-caption-interior', {
                loop: true,
                modules: [Navigation],
                allowTouchMove: false,
                navigation: {
                    nextEl: ".swiper-next-gallery-interior",
                    prevEl: ".swiper-prev-gallery-interior",
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    }
                }
            });
        }

        const swiperGalleryInterior = new Swiper('.swiper-gallery-interior', {
            loop: true,
            modules: [Navigation, Autoplay],
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".swiper-next-gallery-interior",
                prevEl: ".swiper-prev-gallery-interior",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                }
            }
        });

        if (swiperCaptionInterior) {
            swiperGalleryInterior.on('slideChange', () => {
                swiperCaptionInterior.slideToLoop(swiperGalleryInterior.realIndex);
            });
        }
    }

    const swiperGalleryExterior = new Swiper('.swiper-gallery-exterior', {
        loop: true,
        modules: [Pagination, Autoplay],
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".swiper-pagination-gallery-exterior",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            }
        }
    });

    new InitTabs({
        containerId: 'models-tabs',
        contentContainerSelector: '#models-tabs-content'
    });

    new FloorsGraphic({
        defaultColor: '#333',
        highlightColor: '#DA565D',
        graphicSelector: '#grafica_deptos',
        tabsSelector: '#models-tabs'
    });

    const promo = document.querySelector('#promotion-quotes');

    if (promo) {
        const inner = promo.querySelector('.promotion');
        const btnClose = promo.querySelector('.btn-close');

        let cycleInterval;
        let hideTimeout;

        // Función para mostrar con fadeIn
        function fadeIn(element) {
            promo.style.display = 'block';
            // Pequeño delay para que la transición funcione
            setTimeout(() => {
                element.classList.remove('fade-out');
                element.classList.add('fade-in');
            }, 10);
        }

        function fadeOut(element) {
            element.classList.remove('fade-in');
            element.classList.add('fade-out');

            element.addEventListener('transitionend', function handler() {
                promo.style.display = 'none';
                element.removeEventListener('transitionend', handler);
            }, { once: true });
        }

        function startCycle() {
            fadeIn(inner);

            hideTimeout = setTimeout(() => {
                fadeOut(inner);
            }, 10000);
        }

        startCycle();

        // Repetir cada 30 segundos (10s visible + 20s oculto)
        cycleInterval = setInterval(startCycle, 30000);

        if (btnClose) {
            btnClose.addEventListener('click', () => {
                clearTimeout(hideTimeout);
                clearInterval(cycleInterval);
                fadeOut(inner);
            });
        }
    }

});


/*
const loading = document.getElementById('loading');
loading.style.opacity = '0';
loading.style.transition = 'opacity 0.4s ease';

// Ocultar completamente después de la animación
setTimeout(() => {
    loading.style.display = 'none';
}, 400); // 400ms = duración del fade
*/
